module.exports = __webpack_public_path__ + "img/amex.81037bce.svg";